import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function useShellScrollRestoration<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const positions = useRef(new Map<string, number>());
  const { key } = useLocation();
  const committedKey = useRef(key);

  useLayoutEffect(() => {
    committedKey.current = key;
    const top = positions.current.get(key) ?? 0;

    ref.current?.scrollTo({ top, behavior: top ? 'auto' : 'smooth' });
  }, [key]);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const savePosition = () =>
      positions.current.set(committedKey.current, element.scrollTop);

    element.addEventListener('scroll', savePosition, { passive: true });

    return () => element.removeEventListener('scroll', savePosition);
  }, []);

  return ref;
}
